import type { ICellRendererParams } from 'ag-grid-community'
import { Radio } from 'antd'
import React from 'react'
import type { AttendancePlayer } from '../../types'
import { isWaiverLocked } from '@sportninja/common/features/game/attendance/utils/waiverLock'
import { useAttendanceSection } from './AttendanceSectionContext'

/** Starting Goalie / Keeper column (Roster + Roster Spares, non-generic sports). */
const StartingCell = ({ data }: ICellRendererParams<AttendancePlayer>) => {
  const {
    waiverEnforced,
    isSpareCandidate,
    isSoccer,
    allPlayers,
    onStartingChange,
  } = useAttendanceSection()

  if (!data) {
    return null
  }

  const startingLabel = isSoccer ? 'Starting Keeper' : 'Starting Goalie'
  // Currently-playing proposed-starting goalies other than this player — the
  // parent un-stars these when starting this player.
  const otherPlayingGoalies = allPlayers.filter(
    (p) => p.id !== data.id && p.is_proposed_starting
  )

  return (
    <Radio
      checked={!!data.is_proposed_starting}
      disabled={
        isWaiverLocked(data, waiverEnforced, isSpareCandidate) ||
        data.is_suspended
      }
      aria-label={startingLabel}
      onChange={(e) =>
        onStartingChange(data.id, e.target.checked, otherPlayingGoalies)
      }
    />
  )
}

export default StartingCell
